<template>
    <div>
        <app-sub-title :text="'Usuarios del cliente ' + client.name" />
        <app-client-users-filters 
            @filter="onFilter"
        />
        <app-client-users-list 
            :data="data"
            @change-page="onChangePage"
            @remove-user="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop up -->
        <app-pop-up title="Confirmación" id="user-client-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este usuario?</h2></div>
            <div class="buttons" slot="buttons">
                <b-btn variant="confirm" @click="deleteUser(selectedUser)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</b-btn>
            </div>
        </app-pop-up>
        <!-- fin de pop up -->
    </div>
</template>

<script>
import ClientUsersList from './ClientUsersList/ClientUsersList';
import ClientUsersFilters from './ClientUsersFilters/ClientUsersFilters';
import userRepository from '../../../repositories/users.repository.js';
export default {
    components: {
        appClientUsersList: ClientUsersList,
        appClientUsersFilters: ClientUsersFilters
    },
    data(){
        return {
            data: {},
            filters: {},
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            page: 1
        }
    },
    methods: {
        loadUsers() {
            const ur = Object.assign({}, userRepository);
            ur
                .all({...this.filters, client: this.client.id}, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los usuarios del cliente')
                );
        },
        onFilter(filters){
            this.filters = filters;
            this.loadUsers();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadUsers();
        },
        onChangePage(page){
            this.page = page;
            this.loadUsers();
        },
        startRemove(user) {
            this.selectedUser = user;
            this.$bus.$emit('user-client-remove.open');
        },
        deleteUser(user) {
            const ur = Object.assign({}, userRepository);
            ur.deleteUser(user.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadUsers();
                        this.$bus.$emit('user-client-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el usuario del cliente');
                });
        },
    },
    created() {
        this.loadUsers();
    }
}
</script>
